export enum LogLevel {
    Fatal = 0,
    Error = 1,
    Warn = 2,
    Info = 3,
    Debug = 4
}
export function logLevelDescription(value: LogLevel) {
    switch (value) {
        case LogLevel.Fatal:
            return `Fatal`;
        case LogLevel.Error:
            return `Error`;
        case LogLevel.Warn:
            return `Warn`;
        case LogLevel.Info:
            return `Info`;
        case LogLevel.Debug:
            return `Debug`;
    }
}
export interface ILogLevelDescriptor { value: LogLevel; name: string; description: string; }
export let allLogLevel: ILogLevelDescriptor[] = [
    { value: LogLevel.Fatal, name: `Fatal`, description: `Fatal` },
    { value: LogLevel.Error, name: `Error`, description: `Error` },
    { value: LogLevel.Warn, name: `Warn`, description: `Warn` },
    { value: LogLevel.Info, name: `Info`, description: `Info` },
    { value: LogLevel.Debug, name: `Debug`, description: `Debug` }
];

export function getLogLevelDescriptor(value: LogLevel) {
    switch (value) {
        case LogLevel.Fatal:
            return { value: LogLevel.Fatal, name: `Fatal`, description: `Fatal` };
        case LogLevel.Error:
            return { value: LogLevel.Error, name: `Error`, description: `Error` };
        case LogLevel.Warn:
            return { value: LogLevel.Warn, name: `Warn`, description: `Warn` };
        case LogLevel.Info:
            return { value: LogLevel.Info, name: `Info`, description: `Info` };
        case LogLevel.Debug:
            return { value: LogLevel.Debug, name: `Debug`, description: `Debug` };
    }
}
export enum RoleRights {
    UsersGet = 10,
    UsersEdit = 11,
    UsersCreate = 12,
    UsersDelete = 13,
    GroupsGet = 20,
    GroupsEdit = 21,
    GroupsCreate = 22,
    GroupsDelete = 23,
    RightsGet = 30,
    SettingsGet = 40,
    SettingsEdit = 41,
    ClientGet = 50,
    ClientEdit = 51,
    ClientCreate = 52,
    ClientDelete = 53,
    ClientComprehensiveAdministration = 54,
    CategoriesGet = 60,
    CategoriesEdit = 61,
    CategoriesCreate = 62,
    CategoriesDelete = 63,
    ConsultationGet = 70,
    ConsultationEdit = 71,
    ConsultationCreate = 72,
    ConsultationDelete = 73,
    SurveyGet = 80,
    SurveyEdit = 81,
    SurveyCreate = 82,
    SurveyDelete = 83
}
export function roleRightsDescription(value: RoleRights) {
    switch (value) {
        case RoleRights.UsersGet:
            return `Benutzerverwaltung Leserecht`;
        case RoleRights.UsersEdit:
            return `Benutzerverwaltung Bearbeitungsrecht`;
        case RoleRights.UsersCreate:
            return `Benutzerverwaltung Anlegenrecht`;
        case RoleRights.UsersDelete:
            return `Benutzerverwaltung Löschenrecht`;
        case RoleRights.GroupsGet:
            return `Gruppenverwaltung Leserecht`;
        case RoleRights.GroupsEdit:
            return `Gruppenverwaltung Bearbeitungsrecht`;
        case RoleRights.GroupsCreate:
            return `Gruppenverwaltung Anlegenrecht`;
        case RoleRights.GroupsDelete:
            return `Gruppenverwaltung Löschenrecht`;
        case RoleRights.RightsGet:
            return `Benutzerrechte Leserecht`;
        case RoleRights.SettingsGet:
            return `Anwendungseinstellungen Leserecht`;
        case RoleRights.SettingsEdit:
            return `Anwendungseinstellungen Bearbeitungsrecht`;
        case RoleRights.ClientGet:
            return `Mandantenverwaltung Leserecht`;
        case RoleRights.ClientEdit:
            return `Mandantenverwaltung Bearbeitungsrecht`;
        case RoleRights.ClientCreate:
            return `Mandantenverwaltung Anlegenrecht`;
        case RoleRights.ClientDelete:
            return `Mandantenverwaltung Löschenrecht`;
        case RoleRights.ClientComprehensiveAdministration:
            return `Mandantenübergreifende Administration`;
        case RoleRights.CategoriesGet:
            return `Kategorieverwaltung Leserecht`;
        case RoleRights.CategoriesEdit:
            return `Kategorieverwaltung Bearbeitungsrecht`;
        case RoleRights.CategoriesCreate:
            return `Kategorieverwaltung Anlegenrecht`;
        case RoleRights.CategoriesDelete:
            return `Kategorieverwaltung Löschenrecht`;
        case RoleRights.ConsultationGet:
            return `Befragung Leserecht`;
        case RoleRights.ConsultationEdit:
            return `Befragung Bearbeitungsrecht`;
        case RoleRights.ConsultationCreate:
            return `Befragung Anlegenrecht`;
        case RoleRights.ConsultationDelete:
            return `Befragung Löschenrecht`;
        case RoleRights.SurveyGet:
            return `Fragebogen Leserecht`;
        case RoleRights.SurveyEdit:
            return `Fragebogen Bearbeitungsrecht`;
        case RoleRights.SurveyCreate:
            return `Fragebogen Anlegenrecht`;
        case RoleRights.SurveyDelete:
            return `Fragebogen Löschenrecht`;
    }
}
export interface IRoleRightsDescriptor { value: RoleRights; name: string; description: string; }
export let allRoleRights: IRoleRightsDescriptor[] = [
    { value: RoleRights.UsersGet, name: `UsersGet`, description: `Benutzerverwaltung Leserecht` },
    { value: RoleRights.UsersEdit, name: `UsersEdit`, description: `Benutzerverwaltung Bearbeitungsrecht` },
    { value: RoleRights.UsersCreate, name: `UsersCreate`, description: `Benutzerverwaltung Anlegenrecht` },
    { value: RoleRights.UsersDelete, name: `UsersDelete`, description: `Benutzerverwaltung Löschenrecht` },
    { value: RoleRights.GroupsGet, name: `GroupsGet`, description: `Gruppenverwaltung Leserecht` },
    { value: RoleRights.GroupsEdit, name: `GroupsEdit`, description: `Gruppenverwaltung Bearbeitungsrecht` },
    { value: RoleRights.GroupsCreate, name: `GroupsCreate`, description: `Gruppenverwaltung Anlegenrecht` },
    { value: RoleRights.GroupsDelete, name: `GroupsDelete`, description: `Gruppenverwaltung Löschenrecht` },
    { value: RoleRights.RightsGet, name: `RightsGet`, description: `Benutzerrechte Leserecht` },
    { value: RoleRights.SettingsGet, name: `SettingsGet`, description: `Anwendungseinstellungen Leserecht` },
    { value: RoleRights.SettingsEdit, name: `SettingsEdit`, description: `Anwendungseinstellungen Bearbeitungsrecht` },
    { value: RoleRights.ClientGet, name: `ClientGet`, description: `Mandantenverwaltung Leserecht` },
    { value: RoleRights.ClientEdit, name: `ClientEdit`, description: `Mandantenverwaltung Bearbeitungsrecht` },
    { value: RoleRights.ClientCreate, name: `ClientCreate`, description: `Mandantenverwaltung Anlegenrecht` },
    { value: RoleRights.ClientDelete, name: `ClientDelete`, description: `Mandantenverwaltung Löschenrecht` },
    { value: RoleRights.ClientComprehensiveAdministration, name: `ClientComprehensiveAdministration`, description: `Mandantenübergreifende Administration` },
    { value: RoleRights.CategoriesGet, name: `CategoriesGet`, description: `Kategorieverwaltung Leserecht` },
    { value: RoleRights.CategoriesEdit, name: `CategoriesEdit`, description: `Kategorieverwaltung Bearbeitungsrecht` },
    { value: RoleRights.CategoriesCreate, name: `CategoriesCreate`, description: `Kategorieverwaltung Anlegenrecht` },
    { value: RoleRights.CategoriesDelete, name: `CategoriesDelete`, description: `Kategorieverwaltung Löschenrecht` },
    { value: RoleRights.ConsultationGet, name: `ConsultationGet`, description: `Befragung Leserecht` },
    { value: RoleRights.ConsultationEdit, name: `ConsultationEdit`, description: `Befragung Bearbeitungsrecht` },
    { value: RoleRights.ConsultationCreate, name: `ConsultationCreate`, description: `Befragung Anlegenrecht` },
    { value: RoleRights.ConsultationDelete, name: `ConsultationDelete`, description: `Befragung Löschenrecht` },
    { value: RoleRights.SurveyGet, name: `SurveyGet`, description: `Fragebogen Leserecht` },
    { value: RoleRights.SurveyEdit, name: `SurveyEdit`, description: `Fragebogen Bearbeitungsrecht` },
    { value: RoleRights.SurveyCreate, name: `SurveyCreate`, description: `Fragebogen Anlegenrecht` },
    { value: RoleRights.SurveyDelete, name: `SurveyDelete`, description: `Fragebogen Löschenrecht` }
];

export function getRoleRightsDescriptor(value: RoleRights) {
    switch (value) {
        case RoleRights.UsersGet:
            return { value: RoleRights.UsersGet, name: `UsersGet`, description: `Benutzerverwaltung Leserecht` };
        case RoleRights.UsersEdit:
            return { value: RoleRights.UsersEdit, name: `UsersEdit`, description: `Benutzerverwaltung Bearbeitungsrecht` };
        case RoleRights.UsersCreate:
            return { value: RoleRights.UsersCreate, name: `UsersCreate`, description: `Benutzerverwaltung Anlegenrecht` };
        case RoleRights.UsersDelete:
            return { value: RoleRights.UsersDelete, name: `UsersDelete`, description: `Benutzerverwaltung Löschenrecht` };
        case RoleRights.GroupsGet:
            return { value: RoleRights.GroupsGet, name: `GroupsGet`, description: `Gruppenverwaltung Leserecht` };
        case RoleRights.GroupsEdit:
            return { value: RoleRights.GroupsEdit, name: `GroupsEdit`, description: `Gruppenverwaltung Bearbeitungsrecht` };
        case RoleRights.GroupsCreate:
            return { value: RoleRights.GroupsCreate, name: `GroupsCreate`, description: `Gruppenverwaltung Anlegenrecht` };
        case RoleRights.GroupsDelete:
            return { value: RoleRights.GroupsDelete, name: `GroupsDelete`, description: `Gruppenverwaltung Löschenrecht` };
        case RoleRights.RightsGet:
            return { value: RoleRights.RightsGet, name: `RightsGet`, description: `Benutzerrechte Leserecht` };
        case RoleRights.SettingsGet:
            return { value: RoleRights.SettingsGet, name: `SettingsGet`, description: `Anwendungseinstellungen Leserecht` };
        case RoleRights.SettingsEdit:
            return { value: RoleRights.SettingsEdit, name: `SettingsEdit`, description: `Anwendungseinstellungen Bearbeitungsrecht` };
        case RoleRights.ClientGet:
            return { value: RoleRights.ClientGet, name: `ClientGet`, description: `Mandantenverwaltung Leserecht` };
        case RoleRights.ClientEdit:
            return { value: RoleRights.ClientEdit, name: `ClientEdit`, description: `Mandantenverwaltung Bearbeitungsrecht` };
        case RoleRights.ClientCreate:
            return { value: RoleRights.ClientCreate, name: `ClientCreate`, description: `Mandantenverwaltung Anlegenrecht` };
        case RoleRights.ClientDelete:
            return { value: RoleRights.ClientDelete, name: `ClientDelete`, description: `Mandantenverwaltung Löschenrecht` };
        case RoleRights.ClientComprehensiveAdministration:
            return { value: RoleRights.ClientComprehensiveAdministration, name: `ClientComprehensiveAdministration`, description: `Mandantenübergreifende Administration` };
        case RoleRights.CategoriesGet:
            return { value: RoleRights.CategoriesGet, name: `CategoriesGet`, description: `Kategorieverwaltung Leserecht` };
        case RoleRights.CategoriesEdit:
            return { value: RoleRights.CategoriesEdit, name: `CategoriesEdit`, description: `Kategorieverwaltung Bearbeitungsrecht` };
        case RoleRights.CategoriesCreate:
            return { value: RoleRights.CategoriesCreate, name: `CategoriesCreate`, description: `Kategorieverwaltung Anlegenrecht` };
        case RoleRights.CategoriesDelete:
            return { value: RoleRights.CategoriesDelete, name: `CategoriesDelete`, description: `Kategorieverwaltung Löschenrecht` };
        case RoleRights.ConsultationGet:
            return { value: RoleRights.ConsultationGet, name: `ConsultationGet`, description: `Befragung Leserecht` };
        case RoleRights.ConsultationEdit:
            return { value: RoleRights.ConsultationEdit, name: `ConsultationEdit`, description: `Befragung Bearbeitungsrecht` };
        case RoleRights.ConsultationCreate:
            return { value: RoleRights.ConsultationCreate, name: `ConsultationCreate`, description: `Befragung Anlegenrecht` };
        case RoleRights.ConsultationDelete:
            return { value: RoleRights.ConsultationDelete, name: `ConsultationDelete`, description: `Befragung Löschenrecht` };
        case RoleRights.SurveyGet:
            return { value: RoleRights.SurveyGet, name: `SurveyGet`, description: `Fragebogen Leserecht` };
        case RoleRights.SurveyEdit:
            return { value: RoleRights.SurveyEdit, name: `SurveyEdit`, description: `Fragebogen Bearbeitungsrecht` };
        case RoleRights.SurveyCreate:
            return { value: RoleRights.SurveyCreate, name: `SurveyCreate`, description: `Fragebogen Anlegenrecht` };
        case RoleRights.SurveyDelete:
            return { value: RoleRights.SurveyDelete, name: `SurveyDelete`, description: `Fragebogen Löschenrecht` };
    }
}
export enum Setting {
    FrontendBaseUrl = 0,
    MailServerIP = 1,
    MailServerPort = 2,
    MailServerUsername = 3,
    MailServerPassword = 4,
    MailServerEmail = 5,
    MailUseSsl = 6,
    MailWithoutSmtpAuth = 7,
    MailServiceEnabled = 8,
    MailServiceIntervalMinutes = 9
}
export function settingDescription(value: Setting) {
    switch (value) {
        case Setting.FrontendBaseUrl:
            return `FrontendBaseUrl`;
        case Setting.MailServerIP:
            return `MailServerIP`;
        case Setting.MailServerPort:
            return `MailServerPort`;
        case Setting.MailServerUsername:
            return `MailServerUsername`;
        case Setting.MailServerPassword:
            return `MailServerPassword`;
        case Setting.MailServerEmail:
            return `MailServerEmail`;
        case Setting.MailUseSsl:
            return `MailUseSsl`;
        case Setting.MailWithoutSmtpAuth:
            return `MailWithoutSmtpAuth`;
        case Setting.MailServiceEnabled:
            return `MailServiceEnabled`;
        case Setting.MailServiceIntervalMinutes:
            return `MailServiceIntervalMinutes`;
    }
}
export interface ISettingDescriptor { value: Setting; name: string; description: string; }
export let allSetting: ISettingDescriptor[] = [
    { value: Setting.FrontendBaseUrl, name: `FrontendBaseUrl`, description: `FrontendBaseUrl` },
    { value: Setting.MailServerIP, name: `MailServerIP`, description: `MailServerIP` },
    { value: Setting.MailServerPort, name: `MailServerPort`, description: `MailServerPort` },
    { value: Setting.MailServerUsername, name: `MailServerUsername`, description: `MailServerUsername` },
    { value: Setting.MailServerPassword, name: `MailServerPassword`, description: `MailServerPassword` },
    { value: Setting.MailServerEmail, name: `MailServerEmail`, description: `MailServerEmail` },
    { value: Setting.MailUseSsl, name: `MailUseSsl`, description: `MailUseSsl` },
    { value: Setting.MailWithoutSmtpAuth, name: `MailWithoutSmtpAuth`, description: `MailWithoutSmtpAuth` },
    { value: Setting.MailServiceEnabled, name: `MailServiceEnabled`, description: `MailServiceEnabled` },
    { value: Setting.MailServiceIntervalMinutes, name: `MailServiceIntervalMinutes`, description: `MailServiceIntervalMinutes` }
];

export function getSettingDescriptor(value: Setting) {
    switch (value) {
        case Setting.FrontendBaseUrl:
            return { value: Setting.FrontendBaseUrl, name: `FrontendBaseUrl`, description: `FrontendBaseUrl` };
        case Setting.MailServerIP:
            return { value: Setting.MailServerIP, name: `MailServerIP`, description: `MailServerIP` };
        case Setting.MailServerPort:
            return { value: Setting.MailServerPort, name: `MailServerPort`, description: `MailServerPort` };
        case Setting.MailServerUsername:
            return { value: Setting.MailServerUsername, name: `MailServerUsername`, description: `MailServerUsername` };
        case Setting.MailServerPassword:
            return { value: Setting.MailServerPassword, name: `MailServerPassword`, description: `MailServerPassword` };
        case Setting.MailServerEmail:
            return { value: Setting.MailServerEmail, name: `MailServerEmail`, description: `MailServerEmail` };
        case Setting.MailUseSsl:
            return { value: Setting.MailUseSsl, name: `MailUseSsl`, description: `MailUseSsl` };
        case Setting.MailWithoutSmtpAuth:
            return { value: Setting.MailWithoutSmtpAuth, name: `MailWithoutSmtpAuth`, description: `MailWithoutSmtpAuth` };
        case Setting.MailServiceEnabled:
            return { value: Setting.MailServiceEnabled, name: `MailServiceEnabled`, description: `MailServiceEnabled` };
        case Setting.MailServiceIntervalMinutes:
            return { value: Setting.MailServiceIntervalMinutes, name: `MailServiceIntervalMinutes`, description: `MailServiceIntervalMinutes` };
    }
}
export enum State {
    Active = 0,
    Inactive = 1
}
export function stateDescription(value: State) {
    switch (value) {
        case State.Active:
            return `Aktiv`;
        case State.Inactive:
            return `Inaktiv`;
    }
}
export interface IStateDescriptor { value: State; name: string; description: string; }
export let allState: IStateDescriptor[] = [
    { value: State.Active, name: `Active`, description: `Aktiv` },
    { value: State.Inactive, name: `Inactive`, description: `Inaktiv` }
];

export function getStateDescriptor(value: State) {
    switch (value) {
        case State.Active:
            return { value: State.Active, name: `Active`, description: `Aktiv` };
        case State.Inactive:
            return { value: State.Inactive, name: `Inactive`, description: `Inaktiv` };
    }
}
export enum SurveyState {
    Active = 0,
    Inactive = 1,
    Historical = 2
}
export function surveyStateDescription(value: SurveyState) {
    switch (value) {
        case SurveyState.Active:
            return `Aktiv`;
        case SurveyState.Inactive:
            return `Inaktiv`;
        case SurveyState.Historical:
            return `Historisch`;
    }
}
export interface ISurveyStateDescriptor { value: SurveyState; name: string; description: string; }
export let allSurveyState: ISurveyStateDescriptor[] = [
    { value: SurveyState.Active, name: `Active`, description: `Aktiv` },
    { value: SurveyState.Inactive, name: `Inactive`, description: `Inaktiv` },
    { value: SurveyState.Historical, name: `Historical`, description: `Historisch` }
];

export function getSurveyStateDescriptor(value: SurveyState) {
    switch (value) {
        case SurveyState.Active:
            return { value: SurveyState.Active, name: `Active`, description: `Aktiv` };
        case SurveyState.Inactive:
            return { value: SurveyState.Inactive, name: `Inactive`, description: `Inaktiv` };
        case SurveyState.Historical:
            return { value: SurveyState.Historical, name: `Historical`, description: `Historisch` };
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/enums.ts